<template>
	<div class="menu">
		<div class="menu-title" @click="link && $emit('link')">
			<div>
				{{ title }}
			</div>
			<div v-show="link">
				<nio-icon :size="16" :style="{ height: '16px' }" name="icon_arrows_right_2xs" />
			</div>
		</div>

		<div v-for="field in fields" class="menu-field">
			<div class="field-label">
				{{ field.label }}
			</div>

			<div class="field-content" :class="{ bold: field.bold, amount: field.amount }">
				<template v-if="field.copy">
					<span class="field-value">{{ field.value }}</span>
					<span class="field-divider"></span>
					<span class="copy-btn" @click="copyText(field.value)">复制</span>
				</template>

				<template v-else-if="field.link">
					<span @click="$emit('fieldLink', field)">
						<span class="field-value">{{ field.value }}</span>
						<nio-icon name="icon_arrows_right_2xs" />
					</span>
				</template>

				<span class="field-value" v-else>
					{{ field.discount ? '-' : ''
					}}{{ field.amount ? '¥ ' + formatCurrency(field.value) : field.value }}
				</span>
			</div>
		</div>

		<nio-dialog
			v-model="showClipboard"
			title="已复制订单编号"
			:description="orderNo"
			:cancel="null"
			:confirm="{ name: '我知道了', action: () => (showClipboard = false) }"
		></nio-dialog>
	</div>
</template>

<script>
import util from '@/util/util'
import nativeHybrid from '@/util/nativeHybrid'

export default {
	name: 'Menu',
	props: {
		title: {
			type: String,
			required: true
		},
		fields: {
			type: Array,
			required: true
		},
		link: {
			type: Boolean,
			default: false
		},
		orderNo: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			formatCurrency: util.formatCurrency,
			showClipboard: false
		}
	},

	methods: {
		copyText(content) {
			this.showClipboard = true

			nativeHybrid.getCopyText(content)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@nio-fe/nio-app-ui/es/style';
.menu {
	margin-top: 60px;

	.menu-title {
		color: #040b29;
		font-family: 'PingFang SC';
		@include subtitle_1(1.4, 400, false);
		margin-bottom: 20px;

		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.menu-field {
		display: flex;
		justify-content: space-between;
		align-items: center;

		&:not(:last-child) {
			margin-bottom: 16px;
		}

		.field-label {
			color: $color_mb3_front;
			@include body_2(1.5, 400, false);
			min-width: 60px;
		}

		.field-content {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;
			line-height: 22px;
			&.amount {
				.field-value {
					font-family: 'Blue Sky Noto';
				}

				&.bold {
					.field-value {
						font-family: 'Blue Sky Noto-Bold';
					}
				}
			}

			.field-divider {
				height: 10px;
				line-height: 10px;
				border-right: 1px solid $border_divider_primary;
				margin: 0 10px;
			}

			.copy-btn {
				font-size: 14px;
				line-height: 22px;
				text-align: right;

				color: #040b29;
				font-weight: 500;
			}
		}
	}
}
</style>
